import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { Logo } from '@/components/logo';

export const NotFoundPage = () => (
  <div className="flex min-h-svh flex-col items-center justify-center gap-6 px-4 text-center">
    <Logo />

    <div>
      <p className="text-sm font-medium text-ink">This page does not exist</p>
      <p className="mt-1 text-sm text-ink-muted">
        The link may be out of date, or the page may have moved.
      </p>
    </div>

    <Button asChild variant="secondary">
      <Link to="/">Back to overview</Link>
    </Button>
  </div>
);
